import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Study Area</strong>
            </p>
            <p>
              Karnataka State is endowed with a vast inland water spread that
              includes lakes, tanks, reservoirs, rivers, and ponds. Figure 4
              depicts the spatial distribution of wetlands in Karnataka. The
              state is located at 11&deg;30&rsquo;N and 18&deg;30&rsquo;N
              latitudes, 74&deg;E and 78&deg;30&rsquo;E longitudes, and is the
              eighth largest state by area and the ninth largest state by
              population in India. Karnataka state is surrounded by the Arabian
              Sea to the west, Goa to the northwest, Maharashtra to the north,
              Telangana to the northeast, Andhra Pradesh to the east, Tamil Nadu
              to the southeast, and Kerala to the southwest. The state is
              divided into 30 districts, with Bengaluru as the capital city.
              Karnataka has a total land area of 191,967 km<sup>2</sup> (or 5.83
              percent of India's total land area). Rainfall ranges from 500 mm
              to over 4000 mm. Agumbe in the Sahyadris receives the second
              heaviest annual rainfall (7600 mm) in India. Summer temperatures
              range from 18&deg;C &ndash; 40&deg;C, while winter temperatures
              range from 14&deg;C &ndash; 32&deg;C. Ragi, jowar, rice, wheat,
              sugarcane, coconut, groundnut, and cotton are the major crops
              grown in Karnataka.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk4.jpg" alt="" />
            </p>
            <p style={{ textAlign: "center" }}>
              <strong>Figure 4: </strong>Wetlands of Karnataka, India
            </p>
            <p>
              <strong>Valuation of ecosystem service from wetlands</strong>
            </p>
            <p>
              The total ecosystem supply value of wetlands in Karnataka was
              assessed considering (a) provisioning services, (b) regulating
              services, and (c) cultural services. Ecosystem services are
              accounted through the (i) residual value method, and (ii) benefit
              transfer method. This involved data compilation from primary
              (field investigation) and secondary sources (government agencies,
              published articles in peer-reviewed journals). Provisioning
              services of ecosystems are accounted for through the residual
              value (or resource rent) method. The residual value method has
              been used to estimate the value of an ecosystem service by taking
              the gross value of the final marketed good (to which the ecosystem
              service provides input) and then deducting the cost of all
              non-ecosystem inputs, including labour, produced assets, and
              intermediate inputs (SEEA 2021). Benefit transfer involves
              transferring monetary values of ecosystem services from previous
              studies or literature that focused on a different region or time
              period to our area of interest (Ramachandra et al. 2019).
              Regulating and cultural service values are based on case studies
              from India, which are compared with the global ecosystem service
              valuation database (ESVD)
              [https://www.es-partnership.org/wp-content/uploads/2020/08/ESVD_Global-Update-FINAL-Report-June-2020.pdf]
              and published literature (of case studies from India) considering
              GDP (PPP) per capita for India
              (https://data.worldbank.org/indicator/ NY.GDP.PCAP.PP.CD?
              locations=IN) and the currency exchange rate
              (https://www.xe.com/currencyconverter/convert/?Amount=1&amp;From=USD&amp;To
              =INR).
            </p>
            <p>
              The provisioning services considered are microalgae, fish, and
              macrophytes. Microalgae have a relatively shorter cycling period
              (5&ndash;7 days), and the microalgal productivity is 51.1 t/ha/yr.
              Microalgal biodiesel production will be economically viable with
              the economic valorization of residual biomass and extraction of
              value-added products such as glycerol, colloids, etc.
              (Branco-Vieira et al. 2020; Yang et al. 2012). In the current
              study, the total benefit (in Rs/ha/yr) from microalgae was
              computed by considering biodiesel, glycerol, food/protein, and
              feed for fish. Microalgae, being producers in the aquatic food
              chain, sequesters efficiently to the extent of 1.83 kg of carbon
              dioxide by a kilogram of algae (Chisti 2008). The carbon
              sequestration service is accounted for by considering the social
              cost of 80 USD per tonne of carbon dioxide removal (Verma et al.
              2014) and molecular weight ratio (1 tC equals 3.67 tCO<sub>2</sub>
              ). The total value of carbon sequestration is Rs 234404 tCO
              <sub>2</sub>/ha/yr.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk5.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 5:</strong> a) Macrophyte covered area in wetlands,
              and b) tank irrigated area in districts of Karnataka
            </p>
            <p>
              Macrophytes covered 50432.35 ha, which is ~18% of the Karnataka
              wetland area. The spatial extent of macrophytes in wetlands is
              shown district-wise in figure 5a. Benefit from macrophytes was
              computed by considering services such as fodder, honey production,
              food, grazing, and handicrafts. The total value for carbon
              sequestration by macrophyte is Rs. 311.92 kgCO<sub>2</sub>/ha/yr.
            </p>
            <p>
              Fish is a rich source of easily digestible protein,
              polyunsaturated fatty acids, vitamins, and minerals for human
              nutrition (Elaigwu et al. 2019). The average fish catch based on
              field investigations is 495 kg/ha/yr and benefit (residual value)
              from fish (as food) is 65 Rs/kg. The data on irrigation (figure
              5b) and agricultural crops grown in each district of Karnataka was
              obtained from government reports (District at a Glance). The
              values adopted for the valuation of ecosystem services are shown
              in table 3.
            </p>
            <p>
              <strong>Table 3:</strong> Values used for wetland ecosystem
              valuation
            </p>
            <table align="center" width="638">
              <tbody>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>
                      <strong>Symbol</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>
                      <strong>Services</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>
                      <strong>Unit Value (Rs/ha/yr)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>
                      <strong>References</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="3" width="565">
                    <p>
                      <strong>Provisioning Services</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS1</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Microalgae</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>110467</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Field Study</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS2</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Macrophyte</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>11291</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Field Study</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS3</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Fish</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>32175</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Field Study</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS4</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Water</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>15359</p>
                  </td>
                  <td style={styles.cell} rowspan="3" width="176">
                    <p>ESVD, 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS5</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Raw materials</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>13358</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS6</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Genetic resources</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>476</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS7</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Medicinal resources</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>786</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="176">
                    <p>Clarkson et al. 2013</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS8</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Ornamental resources</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>905</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS9</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Fuelwood</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>5833</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>
                      Ramachandra et al. 2005, 2011; Schuijt 2002; Zuze 2013;
                      Schuyt and Brander 2008
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>PS10</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Irrigation</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>1826</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Mukherjee 2008</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="3" width="565">
                    <p>
                      <strong>Regulating Services</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS1</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Air quality regulation</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>270</p>
                  </td>
                  <td style={styles.cell} rowspan="5" width="176">
                    <p>ESVD 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS2</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Climate regulation</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>1191</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS3</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Moderation of extreme events</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>105781</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS4</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Regulation of water flows</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>28891</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS5</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Waste treatment</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>16225</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS6</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Erosion prevention</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>20704</p>
                  </td>
                  <td style={styles.cell} rowspan="3" width="176">
                    <p>Clarkson et al. 2013</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS7</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Maintenance of soil fertility</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>13604</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS8</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Biological control</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>7529</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS9</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Maintenance of life cycles of migratory species</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>14978</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="176">
                    <p>ESVD 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS10</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Maintenance of genetic diversity</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>27216</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS11</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Carbon sequestration</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>234716</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>
                      Verma et al. 2014; Baral et al. 2016; Chisti 2008; Kalita
                      2019
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS12</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Water borne diseases</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>1941</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>
                      Verma et al. 2001; Kant et al. 2013; Ramachandra et al.
                      2011
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS13</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Pollination</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>19</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Schuyt and Brander 2008</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS14</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Water conservation</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>2875</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Li and Gao 2016</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS15</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Flood control</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>7053</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Kaul et al. 2016; Zuze 2013; Schuyt and Brander 2008.</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS16</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Habitat/refugia</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>1825</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Schuyt and Brander 2008; Kaggwa et al. 2009</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>RMS17</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Ground water recharge</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>215123</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Ramachandra et al. 2019; Kaggwa et al. 2009</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>
                      <strong>&nbsp;</strong>
                    </p>
                  </td>
                  <td style={styles.cell} colspan="3" width="565">
                    <p>
                      <strong>Cultural Services</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS1</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Aesthetic information</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>389</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>ESVD 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS2</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Opportunities for recreation and tourism</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>12111</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>
                      Anitha and Muraleedharan 2006; Rao 2018; Verma et al.
                      2001; Dixit et al. 2016; Mishra 2014; Venkatachalam and
                      Zareena Begam 2016; Prasher et al. 2006; Schuijt 2002;
                      Zuze 2013; Schuyt and Brander 2008; Kaggwa et al. 2009;
                      Baral et al. 2016; Li and Gao 2016; Dehlavi and Adil 2011
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS3</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Inspiration for culture, art and design</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>905</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>Ramachandra 2016;</p>
                    <p>
                      Ramachandra et al. 2019; Zuze 2013; Schuyt and Brander
                      2008; Kaggwa et al. 2009
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS4</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Spiritual experience</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>8</p>
                  </td>
                  <td style={styles.cell} rowspan="3" width="176">
                    <p>ESVD 2020</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS5</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Information for cognitive development</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>953</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS6</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Existence and bequest values</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>91312</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="73">
                    <p>CS7</p>
                  </td>
                  <td style={styles.cell} width="271">
                    <p>Education</p>
                  </td>
                  <td style={styles.cell} width="118">
                    <p>29144</p>
                  </td>
                  <td style={styles.cell} width="176">
                    <p>
                      Ramachandra 2016; Ramachandra et al. 2019; Li and Gao 2016
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="4" width="638">
                    <p>
                      The values are adjusted for GDP (PPP) per capita and
                      corresponding currency exchange rate.
                    </p>
                    <p>
                      GDP(PPP) per capita for India:
                      https://data.worldbank.org/indicator/NY.GDP.PCAP.PP.CD?locations=IN
                    </p>
                    <p>
                      Currency exchange rate:
                      https://www.thehansindia.com/business/currency-update-today-indian-rupee-against-us-dollar-on-19-november-2021-716019
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              The provisioning services of wetlands are calculated by equation
              (1). The regulating service (<em>RS</em>) is calculated by
              equation (2), and the cultural service (<em>CS</em>) is calculated
              by equation (3). The total ecosystem supply value (<em>TESV</em>)
              is calculated using equation (4), which is the sum of
              provisioning, regulating, and cultural services. The equation (5)
              is used to calculate the <em>NPV </em>(net present value) of a
              wetland ecosystem (SEEA 2014, 2021), considering a social discount
              rate of 3% and the life of an ecosystem asset of 50 years.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/formula/esk1.png" alt="" />
              &hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
              (1)
            </p>
            <p style={{ textAlign: "center" }}>
              Where, <em>PSn</em> is the total provisioning service district
              wise. <em>n</em> is Karnataka's 1&ndash;30 districts, <em>i</em>{" "}
              is the various provisioning services (<em>i</em> = 1 to 10
              services), <em>An</em> is the wetland area of each district, but
              the area is different for the macrophyte (considered macrophyte
              cover area), irrigation (considered tank irrigated area), and
              fuelwood service (considered annual fuelwood extraction from 10%
              of the macrophyte area).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/formula/esk2.png" alt="" />
              &hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
              (2)
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/formula/esk3.png" alt="" />
              &hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
              (3)
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/formula/esk4.png" alt="" />
              &hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
              (4)
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/formula/esk5.png" alt="" />
              &hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;
              (5)
            </p>
            <p style={{ textAlign: "center" }}>
              where, <em>NPV</em> = net present value; <em>R</em> = net cash
              flow from an ecosystem in year <em>t</em>; <em>T</em> = discount
              period (50 year); and <em>r</em> = discount rate (3%).
              District-wise spatial extent of macrophyte is assessed using
              remote sensing data (Google Earth) and QGIS open-source GIS for
              mapping various wetland ecosystem services.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
